import {loading, stopLoading} from "../../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import Swal from "sweetalert2";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import {initProcessingLog} from "../../common/voe-orders/initProcessingLog";

function initAdminVoeOrdersDetailIndex() {
	// Initialize buttons
	const changeStatusButton = document.querySelector('.change-status-button')
	if (changeStatusButton) {
		changeStatusButton.addEventListener('click', () => {
			const options = {
				title: 'Change Status To',
				input: 'select',
				inputOptions: window['statuses'],
				confirmButtonText: 'Change Status',
				showCancelButton: true,
			};

			Swal.fire(options).then(
				result => {
					if (result.isConfirmed) {
						handleChangeStatusRequest(result.value)
					}
				}
			)
		})
	}

	// Init log container
	initProcessingLog(document.querySelector('.voe-order-processing-log-container'));

	/**
	 * Methods
	 */

	/**
	 * @param value
	 */
	function handleChangeStatusRequest(value) {
		loading();

		const data = {
			'status_id': value,
		};

		Axios.post(window['routes/admin.voe-orders.change-order-status'], data)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initAdminVoeOrdersDetailIndex}
